import SiteWidePromoBannerCarousel from './SiteWidePromoBannerCarousel';

export * from './types';
export default SiteWidePromoBannerCarousel;
